var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeftRegular(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5196 7.99966C17.5196 8.49567 17.1193 8.89847 16.6264 8.89847H4.00771L8.94446 13.6377C9.30254 13.9805 9.31534 14.5515 8.97469 14.9083C8.63407 15.2674 8.06919 15.2803 7.71204 14.9387L1.16442 8.64962C0.986689 8.48257 0.886719 8.24673 0.886719 7.99966C0.886719 7.75259 0.986689 7.52049 1.1634 7.34829L7.71102 1.05923C8.06649 0.718945 8.63196 0.731673 8.97423 1.09105C9.31485 1.44668 9.30205 2.01756 8.944 2.36159L4.00724 7.10085H16.6598C17.1513 7.10122 17.5196 7.50552 17.5196 7.99966Z",
    fill: "#7A7A7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftRegular);
export default __webpack_public_path__ + "static/media/arrow-left-regular.551c1e86fce729fe3f280ba481706f37.svg";
export { ForwardRef as ReactComponent };